<ng-container *ngIf="!hasTransitions">
    <div>
        <p i18n>You have not defined your workflow yet.</p>
        <p i18n>Add your first <strong>workflow Transition</strong> to build the workflow.</p>
        <p><button mat-button (click)="onAddTransition()" i18n>Add workflow Transition</button></p>
    </div>
</ng-container>
<ng-container *ngIf="hasTransitions">
    <eas-workflow-transition-item *ngFor="let item of items; first as isFirst; last as isLast"
                                  [item]="item"
                                  [isLast]="isLast"
                                  [isFirst]="isFirst"
                                  [availableActions]="availableActions"
                                  [availableGuards]="availableGuards"
                                  (editTransition)="onEditTransition($event)"
                                  (deleteTransition)="onDeleteTransition($event)"
                                  (focusTransition)="onFocusTransition($event)"
                                  (patchTransition)="onPatchTransition($event)">
    </eas-workflow-transition-item>
    <div class="mt-4">
        <button mat-flat-button
                color="primary"
                (click)="onAddTransition()"
                i18n>Add Transition</button>
    </div>
</ng-container>
